import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPersonSuperstar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0M8 12.75 12.2 16l1.005-.738-1.686-5.062L15.8 7.185 15.417 6H.583L.2 7.185 4.48 10.2l-1.686 5.062L3.8 16z"
	})
});
export default SvgPersonSuperstar;
